import { usePlayground } from "../../playground-store";
import { Message as IMessage } from "../../types";

import { usePlaygroundChannel } from "./usePlaygroundChannel";

import { Message } from "@/components/Messaging/types";
import { WEBSOCKET_MESSAGE_NAME } from "@/constants";

const useNewMessageListener = () => {
  const playground = usePlayground();

  const handleNewMessage = (payload: Message) => {
    const {
      payload: { message },
      individual_run_request_id,
    }: {
      payload: {
        message: IMessage;
      };
      individual_run_request_id: number;
    } = JSON.parse(payload.data);

    const operation =
      playground.operationStore.getAssociatedOperationByRequestId(individual_run_request_id);

    // Update pre-existing output instance
    if (operation?.output_instance_id) {
      const output = playground.getOutput(operation.output_instance_id!)!;
      const newId = output.addMessage(message);
      playground.operationStore.assignMessageId(operation.id, newId, individual_run_request_id);
      return;
    }

    // Initialize output instance
    const clonedPlayground = playground.clone(operation);
    const newId = clonedPlayground.addMessage(message);

    const output = playground.addOutput(clonedPlayground);
    playground.operationStore.assignOutputId(operation!.id, output.instanceId);

    playground.operationStore.assignMessageId(operation!.id, newId, individual_run_request_id);
  };

  usePlaygroundChannel(WEBSOCKET_MESSAGE_NAME.CREATE_NEW_MESSAGE, handleNewMessage);
};

export default useNewMessageListener;
